import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    range: {
        startDate: null,
        endDate: null
    },
    current: {
        plantid: null,
        lineid: null,
    }
}

export const downtimeSlice = createSlice({
    name: 'downtime',
    initialState,
    reducers: {
        onDowntimeRangeChange: (state, { payload }) => {
            let { startDate, endDate } = payload;
            state.range.startDate = startDate
            state.range.endDate = endDate
        },
        onDowntimeCurrentChange: (state, payload) => {
            let { current } = payload
            state.current = current
        }
    },
})

// Action creators are generated for each case reducer function
export const { onDowntimeRangeChange, onDowntimeCurrentChange } = downtimeSlice.actions

export default downtimeSlice.reducer